import { createContext } from "react";

export const BarControlContext = createContext({
  exists: false,
  bar: undefined,
  childControls: undefined
})
